import { useSEO } from "../hooks/useSEO";
import { PolicyShell, H, BUSINESS } from "./_policyShell";

const Shipping = () => {
  useSEO({
    title: "Shipping & Delivery",
    description:
      "Sterling Bio Ltd shipping and delivery information. Free UK tracked shipping, same-day dispatch on orders confirmed before 14:00 GMT, 1–2 business day delivery via Royal Mail Tracked.",
    path: "/shipping",
  });
  return (
    <PolicyShell kicker="Legal" title="Shipping & Delivery" testid="shipping-page">
      <p className="text-sm text-[#64748B] font-mono uppercase tracking-wider">
        Last updated: 25 February 2026
      </p>
      <p>
        All orders are dispatched from our trading address in London by{" "}
        <strong>{BUSINESS.name}</strong> (Company No. {BUSINESS.companyNo}). The information
        below applies to every order placed through this website.
      </p>

      <H>1. Shipping destinations</H>
      <ul className="list-disc list-outside pl-6 space-y-2">
        <li>
          <strong>UK mainland, Northern Ireland, Channel Islands, Isle of Man</strong> — free
          tracked shipping included with every order.
        </li>
        <li>
          <strong>International</strong> — we do not currently ship outside the United Kingdom.
        </li>
      </ul>

      <H>2. Dispatch &amp; delivery timeframes</H>
      <ul className="list-disc list-outside pl-6 space-y-2">
        <li>
          <strong>Same-day dispatch</strong> for orders <em>paid &amp; confirmed</em> before{" "}
          <strong>14:00 GMT</strong> on a UK business day (Mon–Fri, excluding bank holidays).
        </li>
        <li>
          Orders paid after the 14:00 cut-off ship the <strong>next UK business day</strong>.
        </li>
        <li>
          Estimated delivery: <strong>1–2 UK business days</strong> from dispatch via Royal Mail
          Tracked 24 / 48.
        </li>
        <li>
          You will receive a tracking link by email once a label is generated.
        </li>
      </ul>

      <H>3. Awaiting-payment orders</H>
      <p>
        Bank-transfer orders are held until funds reach our account (UK Faster Payments
        typically clear within seconds via Pay-by-Bank). Once payment is confirmed by our
        payment provider (Wallid), the order moves to dispatch.
        If we do not receive payment within <strong>7 days</strong>, the order is automatically
        cancelled and stock is released back to the catalogue. We send a reminder email after
        24 hours containing a single-click link to complete payment.
      </p>

      <H>4. Packaging</H>
      <p>
        Products are dispatched in discreet plain outer packaging without external indication of
        the contents. Tamper-evident seals are applied to all sealed laboratory consumables —
        once broken, the goods are not returnable (see Refund Policy §3).
      </p>

      <H>5. Carrier delays &amp; lost parcels</H>
      <p>
        Our dispatch SLA covers everything up to handing the parcel to the carrier. Once
        dispatched, transit is the responsibility of Royal Mail. If your parcel has not arrived
        by the estimated delivery date, contact us via{" "}
        <a className="text-[#2C8C9C] hover:underline" href={`mailto:${BUSINESS.email}`}>
          {BUSINESS.email}
        </a>{" "}
        or call{" "}
        <a className="text-[#2C8C9C] hover:underline" href={`tel:${BUSINESS.phone}`}>
          {BUSINESS.phoneDisplay}
        </a>{" "}
        and we will open a carrier investigation. A parcel is officially &quot;lost&quot; once Royal Mail
        confirm 10 working days have elapsed without scan activity — we will reship or refund at
        that point.
      </p>

      <H>6. Failed delivery &amp; return-to-sender</H>
      <p>
        If a parcel is returned to us (incorrect address, recipient unavailable, refused), we
        will email you within 1 business day. We can re-dispatch on request once a re-shipping
        fee covering Royal Mail&apos;s return-and-resend cost has been paid, or refund the order minus
        the original shipping cost incurred.
      </p>

      <H>7. Contact</H>
      <p>
        For any shipping question, email{" "}
        <a className="text-[#2C8C9C] hover:underline" href={`mailto:${BUSINESS.email}`}>
          {BUSINESS.email}
        </a>{" "}
        or call{" "}
        <a className="text-[#2C8C9C] hover:underline" href={`tel:${BUSINESS.phone}`}>
          {BUSINESS.phoneDisplay}
        </a>{" "}
        (UK business hours, 09:00–17:00 GMT, Mon–Fri).
      </p>
    </PolicyShell>
  );
};

export default Shipping;
